<template>
    <el-menu class="c-side-bar" :router="true" :default-active="defaultIndex">
        <div class="c-side-bar-top flex flex-vertical-center">
            <div class="avatar">
                <img
                    :src="userInfo.avatar ? userInfo.avatar : defaultHeader"
                    class="avatar-img"
                    alt=""
                />
            </div>
            <div class="user-info">
                <h3 class="user-info-name">{{ userInfo.real_name }}</h3>
                <p class="user-info-school">{{ userInfo.school }}</p>
                <p class="user-info-grade">{{ num2CN[userInfo.grade - 1] }}</p>
            </div>
        </div>
        <el-menu-item-group v-for="group in menuGroups" :key="group.id">
            <template #title>
                <span>{{ group.name }}</span>
            </template>
            <el-menu-item
                v-for="menu in group.menus"
                :key="menu.id"
                :index="'index_' + menu.id"
                :route="{ name: menu.route }"
                :disabled="defaultRoute === menu.route"
                class="c-side-bar-item"
            >
                <img
                    :src="defaultRoute === menu.route ? menu.activeIcon : menu.icon"
                    class="c-side-bar-icon"
                />
                <span>{{ menu.name }}</span>
            </el-menu-item>
        </el-menu-item-group>
    </el-menu>
</template>

<script>
import lesson from '@images/user/lesson.png';
import lessonActive from '@images/user/lesson-active.png';
import records from '@images/user/records.png';
import recordsActive from '@images/user/records-active.png';
// import order from '@images/user/order.png';
// import orderActive from '@images/user/order-active.png';
// import cls from '@images/user/cls.png';
// import clsActive from '@images/user/cls-active.png';
// import message from '@images/user/message.png';
// import messageActive from '@images/user/message-active.png';
import profile from '@images/user/profile.png';
import profileActive from '@images/user/profile-active.png';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            menuGroups: [
                {
                    id: 1,
                    name: '我的课程',
                    menus: [
                        {
                            id: 2,
                            name: '直播课',
                            icon: lesson,
                            activeIcon: lessonActive,
                            route: 'Home'
                        },
                        {
                            id: 3,
                            name: '课程回放',
                            icon: records,
                            activeIcon: recordsActive,
                            route: 'ReplayList'
                        }
                    ]
                },
                {
                    id: 4,
                    name: '个人管理',
                    menus: [
                        // {
                        //     id: 5,
                        //     name: '我的订单',
                        //     icon: order,
                        //     activeIcon: orderActive,
                        //     route: 'Order'
                        // },
                        // {
                        //     id: 6,
                        //     name: '我的班级',
                        //     icon: cls,
                        //     activeIcon: clsActive,
                        //     route: 'Cls'
                        // },
                        // {
                        //     id: 7,
                        //     name: '消息中心',
                        //     icon: message,
                        //     activeIcon: messageActive,
                        //     route: 'Message'
                        // },
                        {
                            id: 8,
                            name: '个人资料',
                            icon: profile,
                            activeIcon: profileActive,
                            route: 'UserCenter'
                        }
                    ]
                }
            ],
            defaultHeader: require('@images/base/header-exam.png'),
            num2CN: [
                '一年级',
                '二年级',
                '三年级',
                '四年级',
                '五年级',
                '六年级',
                '初一',
                '初二',
                '初三',
                '高一',
                '高二',
                '高三'
            ]
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
        defaultRoute() {
            const { $route } = this;
            return $route.name;
        },
        defaultIndex() {
            const { defaultRoute, menuGroups } = this;
            const menus = [];
            menuGroups.forEach((item) => {
                menus.push(...item.menus);
            });
            const menu = menus.find((item) => item.route === defaultRoute) || {};
            const id = menu.id || 2;
            return 'index_' + id;
        }
    },
    created() {
        this.$store.dispatch('queryUserInfo');
    }
};
</script>

<style lang="scss" scoped>
.c-side-bar {
    width: 240px;
    border-right: 0;
    padding-bottom: 94px;
    background-color: #efefef;
    border-top-left-radius: 24px;
    &-top {
        box-sizing: border-box;
        width: 100%;
        height: 134px;
        border-radius: 24px 0px 0px 0px;
        background: url('~@images/base/side-bar-bg.png') no-repeat center;
        background-size: contain;
        padding-left: 30px;
        .avatar {
            width: 72px;
            height: 72px;
            flex-shrink: 0;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 11px;
            &-img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .user-info {
            &-name {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 800;
                color: #fff;
                margin-bottom: 7px;
            }
            &-school,
            &-grade {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #ffffff;
            }
            &-school {
                margin-bottom: 5px;
            }
        }
    }
    &::v-deep {
        .el-menu-item-group__title {
            padding: 17px 30px 12px !important;
            font-size: 16px;
            color: #9d9c9c;
        }
    }
    &-item {
        padding: 18px 30px !important;
        font-size: 18px;
        color: #333;
        min-height: 56px;
        line-height: initial;
        border-left: 4px solid transparent;
        box-sizing: border-box;
        &.is-active {
            color: #333;
            border-left-color: #7f008f;
            background-color: #fff;
        }
        &.is-disabled {
            opacity: 1;
            cursor: inherit;
            background-color: #fff !important;
        }
        &:hover {
            background-color: #fff;
        }
    }
    &-icon {
        width: 22px;
        object-fit: contain;
        margin-right: 16px;
    }
}
</style>
